import HeaderSection from '../../components/home/HeaderSection';
import FooterSection from '../../components/home/FooterSection';
import PricingCtaBar from '../../components/pricing/PricingCtaBar';
import PricingFaqSection from '../../components/pricing/PricingFaqSection';
import PricingPlansSection from '../../components/pricing/PricingPlansSection';
import PricingTestimonialsSection from '../../components/pricing/PricingTestimonialsSection';
import WhySubscribeSection from '../../components/pricing/WhySubscribeSection';
import { useHomeDashboard } from '../../hooks/useHomeDashboard';
import bannerBg from '../../assets/images/free-courses-banner-bg.png';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function PricingPage() {
  const { data, loading, error } = useHomeDashboard();
  const location = useLocation();

  const scrollToPlans = () => {
    document.getElementById('pricing-plans')?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    if (location.state?.scrollTo === 'pricing-plans') {
      scrollToPlans();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  return (
    <>
      <HeaderSection />

      <section className="relative overflow-hidden">
        <div
          className="absolute inset-0 bg-no-repeat"
          style={{ backgroundImage: `url(${bannerBg})` }}
          aria-hidden
        />
        <div className="absolute inset-0 bg-white/40" aria-hidden />
        <div className="relative z-10 mx-auto max-w-7xl px-4 py-10 sm:px-6 sm:py-12 lg:px-8 lg:py-16">
          <div className="mx-auto max-w-3xl text-center">
            <h1 className="text-2xl font-bold leading-tight text-[#181059] sm:text-3xl lg:text-[40px] lg:leading-[1.15]">
              The Right Plan for Your One Subscription. Unlimited Learning
            </h1>
            <p className="mx-auto mt-4 max-w-2xl text-sm font-medium leading-relaxed text-[#181059] sm:mt-6 sm:text-lg lg:text-[24px]">
            Find the plan that matches your goals and enjoy unlimited learning with premium courses, expert guidance, and exam-ready resources—all in one place.
            </p>
          </div>
        </div>
      </section>

      {error && (
        <p className="mx-auto mt-6 max-w-2xl rounded-lg bg-red-50 px-4 py-3 text-center text-sm text-red-700">
          {error}
        </p>
      )}

      <PricingPlansSection plansByCategory={data?.plansByCategory} loading={loading} />
      <WhySubscribeSection />
      <PricingFaqSection />
      <PricingTestimonialsSection />
      <PricingCtaBar onSubscribe={scrollToPlans} />
      <FooterSection />
    </>
  );
}
